<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">Add {{ extension.type?.displayName }}</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
   </div>
   <form class="extension-form" [formGroup]="form" (ngSubmit)="onCreate()">
      <mat-dialog-content>
         @switch (extension.type?.name) { @case (extensionTypes.Phone) {
         <ndt-extension-phone-details
            [extensionPhone]="extension.extensionPhone ?? null"
            formGroupName="extensionPhone"
            [accountId]="accountId"
            [canEdit]="true"
            [extensions]="extensionsForAdd"
            [externalNumbers]="externalNumbers"
            [extensionGroups]="extensionGroupsForAdd"
            [extensionPrivileges]="extensionPrivileges"
            [accountId]="accountId"
            [showCards]="false"
            [timeZoneId]="timeZoneId"
            [parentFormGroup]="form"
         ></ndt-extension-phone-details>
         } @case (extensionTypes.AutoAttendant) {
         <ndt-extension-auto-attendant-details
            [extensionAutoAttendant]="extension.extensionAutoAttendant ?? null"
            formGroupName="extensionAutoAttendant"
            [accountId]="accountId"
            [timeZoneId]="timeZoneId"
            [showCards]="false"
            [parentFormGroup]="form"
         ></ndt-extension-auto-attendant-details>
         } @case (extensionTypes.ExternalForward) {
         <ndt-extension-external-forward-details
            [extensionExternalForward]="extension.extensionExternalForward ?? null"
            formGroupName="extensionExternalForward"
            [accountId]="accountId"
            [showCards]="false"
            [parentFormGroup]="form"
            [timeZoneId]="timeZoneId"
         ></ndt-extension-external-forward-details>
         } @case (extensionTypes.HuntGroup) {
         <ndt-extension-hunt-group-details
            [extensionHuntGroup]="extension.extensionHuntGroup ?? null"
            [extensionId]="extension.extensionId"
            [extension]="extension"
            [extensions]="extensionsForAdd"
            [extensionGroups]="extensionGroupsForAdd"
            formGroupName="extensionHuntGroup"
            [accountId]="accountId"
            [showCards]="false"
            [parentFormGroup]="form"
            [timeZoneId]="timeZoneId"
         ></ndt-extension-hunt-group-details>
         } @case (extensionTypes.PagingGroup) {
         <ndt-extension-paging-group-details
            [extensionPagingGroup]="extension.extensionPagingGroup ?? null"
            formGroupName="extensionPagingGroup"
            [extensionId]="extension.extensionId"
            [extension]="extension"
            [extensions]="extensionsForAdd"
            [extensionGroups]="extensionGroupsForAdd"
            [accountId]="accountId ?? 0"
            [canEdit]="true"
            [showCards]="false"
            [parentFormGroup]="form"
            [timeZoneId]="timeZoneId"
         ></ndt-extension-paging-group-details>
         } @case (extensionTypes.VoiceMailbox) {
         <ndt-extension-mail-box-details
            [extensionMailbox]="extension.extensionMailbox ?? null"
            formGroupName="extensionMailbox"
            [accountId]="accountId"
            [showCards]="false"
            [parentFormGroup]="form"
            [timeZoneId]="timeZoneId"
         ></ndt-extension-mail-box-details>
         } @case (extensionTypes.CallQueue) {
         <ndt-extension-queue-details
            [extensionQueue]="extension.extensionQueue ?? null"
            [extensions]="extensionsForAdd"
            [extensionGroups]="extensionGroupsForAdd"
            [canEdit]="true"
            formGroupName="extensionQueue"
            [accountId]="accountId"
            [showCards]="false"
            [parentFormGroup]="form"
            [timeZoneId]="timeZoneId"
         >
         </ndt-extension-queue-details>
         } @case (extensionTypes.Fax) {
         <ndt-extension-fax-details
            [extensionFax]="extension.extensionFax ?? null"
            formGroupName="extensionFax"
            [accountId]="accountId"
            [showCards]="false"
            [parentFormGroup]="form"
            [timeZoneId]="timeZoneId"
            [extensionPrivileges]="extensionPrivileges"
         >
         </ndt-extension-fax-details>
         } @case (extensionTypes.FindMeFollowMe) {
         <ndt-extension-fmfm-details
            [extensionFmFm]="extension.extensionFmFm ?? null"
            formGroupName="extensionFindMeFollowMe"
            [accountId]="accountId"
            [canEdit]="true"
            [showCards]="false"
            [parentFormGroup]="form"
            [timeZoneId]="timeZoneId"
         ></ndt-extension-fmfm-details>
         } } @if ( extension.type?.name === extensionTypes.Phone || extension.type?.name === extensionTypes.VoiceMailbox
         ) {
         <mat-form-field>
            <mat-label>Mailbox Email Address</mat-label>
            <ng-container formGroupName="mailbox">
               <input
                  matInput
                  autocomplete="off"
                  type="text"
                  formControlName="emailAddress"
                  id="478f1c25-d832-447e-aa6b-b87f33ce83bb"
               />
            </ng-container>
            @if (form.get('mailbox.emailAddress')?.hasError('pattern')) {
            <mat-error> Invalid Email Address </mat-error>
            }
         </mat-form-field>
         }
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="button" title="Save and Add Another" mat-stroked-button (click)="onCreate(true)"
            >Save and Add Another</button
         >
         <button type="submit" title="Create" mat-raised-button id="99c91a62-15a9-4437-8d83-8c8dff57ec43">Save</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
